export default __webpack_public_path__ + "static/media/TF_07.b509e400.png";